module.exports = __webpack_public_path__ + "static/template-about-hero-background-d2a423cfcac9319192693dd02561c237.jpg";